module.exports = __webpack_public_path__ + "img/uil_calender.b642994d.svg";